import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from 'app/store'
import {
  getStoredThemeMode,
  ThemeMode,
  ContrastMode,
  DEFAULT_CONTRAST_MODE
} from 'config/theme'

interface ThemeState {
  mode: ThemeMode
  contrast: ContrastMode
}

const initialState: ThemeState = {
  mode: getStoredThemeMode(),
  contrast: DEFAULT_CONTRAST_MODE
}

const themeSlice = createSlice({
  name: 'themeReducer',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload
    },
    toggleThemeMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
    },
    setThemeContrast: (state, action: PayloadAction<ContrastMode>) => {
      state.contrast = action.payload
    }
  }
})

export const { setThemeMode, toggleThemeMode, setThemeContrast } =
  themeSlice.actions
export const selectThemeMode = (state: AppState): ThemeMode =>
  state.themeReducer.mode

export const selectThemeContrast = (state: AppState): ContrastMode =>
  state.themeReducer.contrast

export default themeSlice.reducer
